import angular from 'angular';
import 'ui-select';
import 'ng-flow';
import './webSectionsServices';

const webSectionsControllers = angular.module('applicationModule.webSectionsControllers', [
    'applicationModule.webSectionsServices',
    'flow',
    'ui.select'
]);

webSectionsControllers.controller('WebSectionController', [
    '$scope', '$rootScope', '$stateParams', '$modal', '$state', 'growl', 'Webpages', 'Webmodules', 'WebSections',
    function ($scope, $rootScope, $stateParams, $modal, $state, growl, Webpages, Webmodules, WebSections) {
        'use strict';

        $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
        $rootScope.$broadcast('wwwModules', {app: $stateParams.application_id});

        const content = document.getElementById('content').offsetTop;
        window.scrollTo({top: content, behavior: 'smooth'});

        $scope.writeAccess = true;
        $scope.container = $stateParams.container;
        $scope.pageId = $stateParams.page_id;
        $scope.appId = $stateParams.application_id;
        $scope.isLoading = true;
        $scope.section = {
            modules: {},
            is_tab: false,
            is_method: false,
            active: 1,
            tabs: [],
            application_id: $scope.appId,
            page_id: $scope.pageId,
            container: $scope.container,
            recipients: {
                all: true
            },
            tab_images: [],
            tab_hover_images: [],
            tab_name: '',
            tab_subtitle: '',
            macroregions: [],
            departments: [],
            sectors: []
        };
        $scope.isCollapseTab = {};
        $scope.editTabs = {};
        $scope.upload = undefined;
        $scope.fileUploaded = false;
        $scope.fileName = undefined;
        $scope.uploads = {};
        $scope.fileUploads = {};
        $scope.invalidContractor = undefined;
        $scope.tabErrorEdit = [];
        $scope.showEdit = [];
        $scope.newValue = [];
        $scope.showSubEdit = [];
        $scope.subValue = [];
        $scope.totalCols = [];
        $scope.totalRows = [];
        $scope.requiredFields = [ 'kontrahent' ];
        $scope.recipient_data = { //object with default values
            macroregions: [],
            departments: [],
            sectors: []
        };
        $scope.recipient_data_added = {
            macroregions: false,
            departments: false,
            sectors: false
        };

        WebSections.create($scope.appId, $scope.container, $scope.pageId)
            .then(function (response) {
                if (response.data.success) {
                    $scope.data = response.data;
                    $scope.package_id = response.data.package_id;
                    $scope.pageLayout = true;
                    $rootScope.$broadcast('wwwStructure', {app: $stateParams.application_id, limit: 10});
                    if (angular.isDefinedNotEmpty($stateParams.section_id)) {
                        $scope.sectionId = $stateParams.section_id;
                        $scope.editMode = true;
                        $scope.isLoading = true;
                        return WebSections.get($scope.sectionId, $stateParams.application_id)
                            .then(function (result) {
                                let data = result.data;

                                if (data.success) {
                                    $scope.section = data.section;
                                    $scope.selectTemplate($scope.section.template);
                                    if ($scope.section.tabs.length > 0) {
                                        $scope.isSet($scope.section.tabs[0]);
                                        angular.forEach($scope.section.tab_images, function (val, key) {
                                            if (angular.isDefinedNotNull($scope.section.tab_images[key])) {
                                                $scope.fileUploads[key] = true;
                                            }
                                        });
                                        angular.forEach($scope.section.tab_hover_images, function (val, key) {
                                            if (angular.isDefinedNotNull($scope.section.tab_hover_images[key])) {
                                                $scope.fileUploads[key] = true;
                                            }
                                        });
                                    }
                                    if ($scope.section.modules.length === 0 && $scope.section.is_tab === true) {
                                        $scope.section.modules = {};
                                    }
                                    if ($scope.section.is_tab) {
                                        $scope.section.is_tab = true;
                                    } else {
                                        $scope.section.is_tab = false;
                                    }
                                    if ($scope.section.is_method) {
                                        $scope.section.is_method = true;
                                    } else {
                                        $scope.section.is_method = false;
                                    }
                                    if ($scope.section.contractors[0]) {
                                        $scope.fileName = $scope.section.contractors[0];
                                        $scope.fileUploaded = true;
                                    }
                                }
                            }).then(function () {
                                $scope.isLoading = false;
                            });
                    }
                }
                $scope.isLoading = false;
            });

        $scope.saveSection = function () {
            $scope.tabError = false;
            $scope.$broadcast('show-errors-check-validity');

            if ($scope.section.is_tab && $scope.section.tabs.length === 0) {
                $scope.tabError = true;
            }

            if ($scope.section.template === 30) {
                const modulesCount = $scope.section.cols * $scope.section.rows;
                if (modulesCount < Object.keys($scope.section.modules).length) {
                    const tmp = {};
                    angular.forEach($scope.section.modules, function(value, key) {
                        if (key < modulesCount) {
                            tmp[key] = $scope.section.modules[key];
                        }
                    });
                    $scope.section.modules = tmp;
                }
            }

            if ($scope.sectionForm.$valid && !$scope.tabError) {
                $scope.isLoading = true;
                WebSections.save($scope.section, $scope.upload, $scope.editMode).then(result => {
                    let data = result.data;
                    if (data.success) {
                        growl.success('MODULES.APPLICATIONS.MODULES.WWW.SECTION.SUCCESS.' + ($scope.editMode ? 'EDITED' : 'CREATED'));
                        $state.go('appsoup.application.webpages', {
                            application_id: $stateParams.application_id,
                            page_id: $stateParams.page_id
                        });
                    } else {
                        if (typeof data.error === 'object') {
                            $scope.formErrors = data.error;
                            if (data.error.contractors) {
                                $scope.invalidContractor = data.error.contractors;
                            }
                        } else {
                            growl.error('MODULES.APPLICATIONS.MODULES.WWW.SECTION.ERROR.' + ($scope.editMode ? 'EDITED' : 'CREATED'));
                        }
                    }
                }).then(() => {
                    $scope.isLoading = false;
                });
            }
        };

        $scope.selectTemplate = function (template) {
            $scope.modules = [];
            $scope.modules.push({'id': null, 'name': '--  Brak --'});
            if (template === 33) {
                $scope.data.modules = $scope.data.all_modules;
            }
            angular.forEach($scope.data.modules, function (val, key) {
                if (checkAvailableModules($scope.data.avaible_modules[template], $scope.data.module_types[val.template])) {
                    $scope.modules.push($scope.data.modules[key]);
                }
            });
        };

        function checkAvailableModules(modules, module) {
            return (angular.isDefined(modules['all']) || angular.isDefined(modules[module]));
        }

        $scope.addTab = function (tabName, tabSubtitle) {
            $scope.section.tabError = false;
            $scope.section.requiredError = false;

            if (angular.isUndefinedNullOrEmpty(tabName)) {
                $scope.section.requiredError = true;
            }
            if ($scope.section.tabs.indexOf(tabName) !== -1) {
                $scope.section.tabError = true;
            }

            if ($scope.section.tabError || $scope.section.requiredError) {
                return;
            }

            $scope.section.tabs.push(tabName);
            $scope.section.tab_name = '';

            if ($scope.section.tabs.length === 1) {
                $scope.isSet($scope.section.tabs[0]);
            }

            if (angular.isUndefinedNullOrEmpty(tabSubtitle)) {
                $scope.section.tab_subtitles.push(null);
            } else {
                $scope.section.tab_subtitles.push(tabSubtitle);
            }

            if ($scope.section.tab_subtitles.length === 1) {
                $scope.isSet($scope.section.tab_subtitles[0]);
            }
            $scope.section.tab_subtitle = '';
        };

        $scope.editTab = function (key) {
            delete $scope.tabErrorEdit[key];
            $scope.showEdit[key] = !$scope.showEdit[key];
            $scope.newValue[key] = $scope.section.tabs[key];

            $scope.showSubEdit[key] = !$scope.showSubEdit[key];
            $scope.subValue[key] = $scope.section.tab_subtitles[key];
        };

        $scope.saveTab = function (newVal, tabName, subVal, tabSubtitles, key) {
            delete $scope.tabErrorEdit[key];
            if (newVal) {
                var tabsList = angular.copy($scope.section.tabs);
                var index = tabsList.indexOf(tabName);
                tabsList.splice(index, 1);

                if (tabsList.indexOf(newVal) === -1) {
                    $scope.showEdit[key] = false;
                    $scope.showSubEdit[key] = false;
                    $scope.section.tabs[key] = newVal;
                    if (newVal !== tabName) {
                        $scope.section.modules[newVal] = $scope.section.modules[tabName];
                        delete $scope.section.modules[tabName];
                        $scope.section.modules.push(newVal);
                    } else {
                        $scope.section.modules[newVal] = angular.copy($scope.section.modules[tabName]);
                    }
                } else {
                    $scope.tabErrorEdit[key] = 'ERROR.UNIQUE.TAB';
                }
            } else {
                $scope.tabErrorEdit[key] = 'ERROR.REQUIRE.TAB';
            }

            if (subVal) {
                var tabSubtitlesList = angular.copy($scope.section.tab_subtitles);
                var subIndex = tabSubtitlesList.indexOf(tabSubtitles);
                tabSubtitlesList.splice(subIndex, 1);

                $scope.showSubEdit[key] = false;
                $scope.section.tab_subtitles[key] = subVal;
            } else {
                $scope.showSubEdit[key] = false;
                $scope.section.tab_subtitles[key] = null;
            }
        };

        function unsetEditTabMode() {
            angular.forEach($scope.section.tabs, function (value, key) {
                if ($scope.showEdit[key]) {
                    $scope.editTab(key);
                }
            });
        }

        $scope.removeTab = function (tab, index) {
            unsetEditTabMode();
            $scope.section.tabs.splice(index, 1);
            $scope.section.tab_subtitles.splice(index, 1);
        };

        $scope.remove = function ($event) {
            $event.stopImmediatePropagation();
        };

        $scope.isSet = function (tabName) {
            $scope.tabActive = tabName;
        };

        $scope.isActive = function (tabName) {
            return $scope.tabActive === tabName;
        };

        $scope.nullSafe = function (field) {
            if (angular.isNullorUndefined($scope.modules[field])) {
                $scope.modules[field] = {};
            }
        };

        $scope.tab_upEnable = function (key) {
            if ($scope.section.tabs[key - 1] || $scope.section.tab_subtitles[key - 1]) {
                return true;
            }

            return false;
        };

        $scope.tab_downEnable = function (key) {
            if ($scope.section.tabs[key + 1] || $scope.section.tab_subtitles[key + 1]) {
                return true;
            }

            return false;
        };

        $scope.tab_changeOrder = function ($event, key1, key2) {
            unsetEditTabMode();
            $event.stopImmediatePropagation();

            $scope.section.tabs = changeOrder($scope.section.tabs, key1, key2);
            $scope.section.tab_subtitles = changeOrder($scope.section.tab_subtitles, key1, key2);
            $scope.section.tab_images = changeOrder($scope.section.tab_images, key1, key2);
            $scope.section.tab_hover_images = changeOrder($scope.section.tab_hover_images, key1, key2);
        };

        function changeOrder(container, key1, key2) {
            var tmpContainer = angular.copy(container[key1]);
            container[key1] = angular.copy(container[key2]);
            container[key2] = tmpContainer;

            return container;
        }

        $scope.removeFile = function () {
            $scope.upload = undefined;
            $scope.invalidContractor = undefined;
            $scope.section.contractors = [];
            $scope.fileUploaded = false;
            $scope.fileName = undefined;
        };

        $scope.uploadSuccess = function (file) {
            $scope.upload = file;
            $scope.fileUploaded = true;
            $scope.fileName = undefined;
            $scope.$apply();
        };

        $scope.cancel = function () {
            $state.go('appsoup.application.webpages', {
                application_id: $stateParams.application_id,
                page_id: $stateParams.page_id
            });
        };
        $scope.inputErrors = {
            'name': [{type: '$invalid', msg: 'ERROR.REQUIRE.NAME'}],
            'template': [{type: '$invalid', msg: 'ERROR.REQUIRE.TEMPLATE'}],
            'left_column_number': [{type: '$invalid', msg: 'FORM.ERRORS.INVALID'}],
            'cols': [{type: '$invalid', msg: 'FORM.ERRORS.INVALID'}],
            'rows': [{type: '$invalid', msg: 'FORM.ERRORS.INVALID'}]
        };

        $scope.changeChoices = function (search, name) {
            if (!search)
                return $scope.recipient_data[name];

            var newChoice = $scope.recipient_data[name];
            if ($scope.recipient_data_added[name]) {
                newChoice.shift();
            }
            if (search && newChoice.indexOf(search) === -1) {
                newChoice.unshift(search);
                $scope.recipient_data_added[name] = true;
            }
            $scope.recipient_data[name] = newChoice;

            return newChoice;
        };

        $scope.$watch('section.template', function (newValue, oldValue) {
            if (newValue && oldValue && newValue !== oldValue) {
                $scope.section.modules = {};
                $scope.section.tab_images = [];
                $scope.section.tab_hover_images = [];
                $scope.section.tabs = [];
                $scope.section.tab_subtitles = [];
                $scope.section.is_tab = false;
                $scope.section.is_method = false;

                delete $scope.section.cols;
                delete $scope.section.rows;
            }
        });

        $scope.$watchGroup([ 'section.cols', 'section.rows' ], function (newValues, oldValues) {
            if ((newValues[0] !== oldValues[0] || newValues[1] !== oldValues[1]) && $scope.section.template === 30) {
                var template = $scope.section.template;
                var index = 0;
                var cols = $scope.section.cols;
                var rows = $scope.section.rows;

                $scope.data.template_structures[template] = [];
                if (cols > 0 && rows > 0) {

                    $scope.totalCols = [];
                    $scope.totalRows = [];

                    for (var c = 0; c < cols; c++) {
                        $scope.totalCols.push(c);
                    }
                    for (var r = 0; r < rows; r++) {
                        $scope.totalRows.push(r);
                    }

                    for (var i = 0; i < cols; i++) {
                        for (var j = 0; j < rows; j++) {
                            $scope.data.template_structures[template].push({
                                key: index,
                                value: (index + 1).toString()
                            });
                            index++;
                        }
                    }
                }
            }
        });
    }
]);

export default webSectionsControllers;
